<nav class="navbar navbar-light bg-light header">
  <a class="navbar-brand" routerLink="/">
    <img class="img-logo" alt="" src="assets/images/logoheadertransp1.png" />
  </a>

  <div class="col-3 align-self-end dados" *ngIf="dadosCertificado">
    <div class="grauSigilo">
      <span title="#EXTERNO.CONFIDENCIAL">#EXTERNO.CONFIDENCIAL</span>
    </div>

    <b>Certificado logado: </b> <br />
    <b>{{labelNome}}:</b> {{ dadosCertificado.de_nome_comum }}<br />


    <div *ngIf="isCnpj">
      <b>{{labelcpfCnPjCei}}: {{ inscricao | cnpj }} </b>
      <b> / CPF:</b> {{ cpf | cpf }} <br />
      <b>Responsável:</b> {{ dadosCertificado.no_responsavel }}<br />
      <b>Perfil:</b> {{dadosCertificado.de_perfil}}
    </div>

    <div *ngIf="isCei">
      <b>{{labelcpfCnPjCei}}: {{ inscricao | mask: '00.000.00000/00' }} </b>
      <b> / CPF:</b> {{ cpf | cpf }} <br />
      <b>Responsável:</b> {{ dadosCertificado.no_responsavel }}<br />
      <b>Perfil:</b> {{dadosCertificado.de_perfil}}
    </div>

    <div *ngIf="isCpf">
      <b>{{labelcpfCnPjCei}}: {{ inscricao | cpf }} </b> <br />
      <b>Perfil:</b> {{dadosCertificado.de_perfil}}
      <br /> <br />
    </div>
  </div>
  <div class="col-3 align-self-end dados" *ngIf="dadosOutorgante">
    <b>Dados do Outorgante: </b> <br />
    <b>{{labelNomeOutorgante}}:</b> {{ dadosOutorgante.razao }}<br />

    <div *ngIf="isCnpjOutorgante">
      <b>{{labelInscricaoOutorgante}}: {{ inscricaoOutorgante | cnpj }} </b>
      <b> / CPF:</b> {{ cpfOutorgante | cpf }} <br />
      <b>Responsável:</b> {{ dadosOutorgante.responsavel }}<br />
      <b>Perfil:</b> {{dadosOutorgante.perfil}}
    </div>

    <div *ngIf="isCeiOutorgante">
      <b>{{labelInscricaoOutorgante}}: {{ inscricaoOutorgante | mask: '00.000.00000/00' }} </b>
      <b> / CPF:</b> {{ cpfOutorgante | cpf }} <br />
      <b>Responsável:</b> {{ dadosOutorgante.responsavel }}<br />
      <b>Perfil:</b> {{dadosOutorgante.perfil}}
    </div>

    <div *ngIf="isCpfOutorgante">
      <b>{{labelInscricaoOutorgante}}: {{ cpfOutorgante | cpf }} </b> <br />
      <b>Perfil:</b> {{dadosOutorgante.perfil}}
      <br /> <br />
    </div>
  </div>
</nav>
<div class="header" align="right">
  <button mat-button class="dados" (click)="redirecionaCnsPortal()">Voltar</button>
</div>

<div class="barra"></div>